module.exports = "<div class=\"container-fluid container-limited\">\n\n<div class=\"row\">\n\t<div class=\"col-sm-12\">\n\t\t<h1><i class=\"fa fa-envelope-o\"></i> {{'JUSTREGISTERED_Title' | translate}} {{name}}</h1>\n\t\t<h5 translate>JUSTREGISTERED_Hint</h5>\n\t\t<p>{{'JUSTREGISTERED_Text1' | translate}}<strong> {{email}} </strong>{{'JUSTREGISTERED_Text2' | translate}}</p>\n\t\t<p translate>JUSTREGISTERED_Text3</p>\n\t</div>\n</div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/account/other/justregistered.html
// module id = 121
// module chunks = 0